module.exports = __webpack_public_path__ + "img/banner1.345da4d3.jpg";